/**
 * Resource that represents an Asn.
 *
 * @name Asn
 * @class
 * @augments TmrResource
 */
export const factory = [
  'Asn',
  /*@ngInject*/ (TmrResource, Place) => {
    let referencedProperties = [
      { property: 'originPlace', resource: Place },
      { property: 'destinationPlace', resource: Place },
    ]
    let Asn = TmrResource('Asn', {}, referencedProperties)
    return Asn
  },
]
